import { queryByFileId } from '../api/upload'
import dayjs from 'dayjs'

const formattime = (t) => {
  if (t) {
    return dayjs(t).format('YYYY-MM-DD HH:mm:ss')
  }
  return t
}

export const fiterData = async (oldData) => {
  const fiterRules = [
    'businessLicense',
    'tenderFileId',
    'tenderMateriaFileId',
    'urgent',
    'bidderQualification',
    'dutyPaidProof',
    'openingDate',
    'guaranteeStartDate',
    'openingPermit',
    'apiName',
    'attr1',
    'attr2',
    'attr3',
  ]
  const [
    businessLicense,
    tenderFileId,
    tenderMateriaFileId,
    dutyPaidProof,
    openingPermit,
    attr1,
    attr2,
    attr3,
  ] = await Promise.all([
    getName(oldData.businessLicense),
    getName(oldData.tenderFileId),
    getName(oldData.tenderMateriaFileId),
    getName(oldData.dutyPaidProof),
    getName(oldData.openingPermit),
    getName(oldData.attr1),
    getName(oldData.attr2),
    getName(oldData.attr3),
  ])
  const rules = {
    businessLicense: businessLicense.data?.fileName,
    urgent: oldData.urgent ? '是' : '否',
    bidderQualification: oldData.bidderQualification === '1' ? '是' : '否',
    apiName: getApiName(oldData.apiName),
    tenderFileId: tenderFileId.data?.fileName,
    tenderMateriaFileId: tenderMateriaFileId.data?.fileName,
    dutyPaidProof: dutyPaidProof.data?.fileName,
    openingDate: formattime(oldData.openingDate),
    guaranteeStartDate: formattime(oldData.guaranteeStartDate),
    openingPermit: openingPermit.data?.fileName,
    attr1: attr1.data?.fileName,
    attr2: attr2.data?.fileName,
    attr3: attr3.data?.fileName,
  }
  fiterRules.map((i) => {
    if (Reflect.has(oldData, i)) {
      oldData[i] = rules[i]
    }
    return
  })
}
async function getName(id) {
  if (!id) return ''
  return await queryByFileId({ fileId: id })
}

function getApiName(e) {
  return e ? '其他来源' : '招采进宝'
}
